import React, { useContext } from 'react';
import List from '@mui/material/List';
import { useTranslation } from 'react-i18next';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ListSubheader from '@mui/material/ListSubheader';
import DescriptionIcon from '@mui/icons-material/Description';
import ChatIcon from '@mui/icons-material/Chat';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import useRoutes from '../../components/_hook/useRoutes';
import DrawerListItem from '../../components/_header/DrawerListItem';
import Context from '../../context';

export default function ProcurementDrawer() {
  const { path } = useRoutes();
  const { company } = useContext(Context);
  const { t } = useTranslation();

  return (
    <>
      <List>
        <DrawerListItem
          path={path('procurement.dashboard', {
            companyID: company._id,
          })}
          primaryText={t('dashboard')}
          icon={<DashboardIcon />}
        />
        <ListSubheader>{t('incoming')}</ListSubheader>
        <DrawerListItem
          path={path('procurement.incoming.request_for_quotes', {
            companyID: company._id,
          })}
          primaryText={t('request_for_quote', { count: 2 })}
          icon={<DescriptionIcon />}
          className="procurement-drawer-incoming-rfq-list-item-joyride"
        />
        <DrawerListItem
          path={path('procurement.incoming.enquiries', {
            companyID: company._id,
          })}
          primaryText={t('enquiry', { count: 2 })}
          icon={<ChatIcon />}
          className="procurement-drawer-incoming-enquiries-list-item-joyride"
        />
        <DrawerListItem
          path={path('procurement.incoming.quotations', {
            companyID: company._id,
          })}
          primaryText={t('quotation', { count: 2 })}
          icon={<InsertDriveFileIcon />}
          className="procurement-drawer-incoming-quotations-list-item-joyride"
        />
        <DrawerListItem
          path={path('procurement.incoming.orders', {
            companyID: company._id,
          })}
          primaryText={t('order', { count: 2 })}
          icon={<DescriptionIcon />}
          className="procurement-drawer-incoming-orders-list-item-joyride"
        />
        <DrawerListItem
          path={path('procurement.incoming.delivery_notes', {
            companyID: company._id,
          })}
          primaryText={t('delivery_note', { count: 2 })}
          icon={<LocalShippingIcon />}
          className="procurement-drawer-incoming-delivery-notes-list-item-joyride"
        />
        <ListSubheader>{t('outgoing')}</ListSubheader>
        <DrawerListItem
          path={path('procurement.outgoing.request_for_quotes', {
            companyID: company._id,
          })}
          primaryText={t('request_for_quote', { count: 2 })}
          icon={<DescriptionIcon />}
          className="procurement-drawer-outgoing-rfq-list-item-joyride"
        />
        <DrawerListItem
          path={path('procurement.outgoing.enquiries', {
            companyID: company._id,
          })}
          primaryText={t('enquiry', { count: 2 })}
          icon={<ChatIcon />}
          className="procurement-drawer-outgoing-enquiries-list-item-joyride"
        />
        <DrawerListItem
          path={path('procurement.outgoing.quotations', {
            companyID: company._id,
          })}
          primaryText={t('quotation', { count: 2 })}
          icon={<InsertDriveFileIcon />}
          className="procurement-drawer-outgoing-quotations-list-item-joyride"
        />
        <DrawerListItem
          path={path('procurement.outgoing.orders', {
            companyID: company._id,
          })}
          primaryText={t('order', { count: 2 })}
          icon={<DescriptionIcon />}
          className="procurement-drawer-outgoing-orders-list-item-joyride"
        />
        <DrawerListItem
          path={path('procurement.outgoing.delivery_notes', {
            companyID: company._id,
          })}
          primaryText={t('delivery_note', { count: 2 })}
          icon={<LocalShippingIcon />}
          className="procurement-drawer-outgoing-delivery-notes-list-item-joyride"
        />
      </List>
    </>
  );
}
